// ~/forms/DynamicDataList.tsx

import { createTsForm, useTsController } from '@ts-react/form';
import { z } from 'zod';

import { DataListItem } from '../ui/data-list';
import { Label } from '../ui/label';

const createDataListItemField = (type) =>
  function DataListItemField(props) {
    // console.createdebug('[createDataListItemField] props:', propscreatecreate);

    const { name } = props;

    const {
      field: { onChange, value },
      error,
    } = useTsController<string>();

    return (
      <div>
        <DataListItem title={name} description={type} />
      </div>
    );
  };

function ArraySubForm(props: { req: Record<any, any> }) {
  console.debug('ArraySubForm', props);
  const { name, req } = props;

  const {
    field: { onChange, value },
    error,
  } = useTsController<string>();

  return (
    <div>
      <Label>{name}</Label>
      {Object.entries(req ?? {}).map(([key, value]) => {
        console.debug({ key, value });
        return (
          <div key={key}>
            <DataListItem title={`${name}.${key}`} description={value} />
          </div>
        );
      })}
    </div>
  );
}

function SubForm(props: { req: Record<any, any> }) {
  // console.debug('SubForm', props);
  const { name, req } = props;

  return (
    <div>
      <Label>{name}</Label>
      {Object.entries(req ?? {}).map(([key, value]) => {
        console.debug({ key, value });
        return (
          <div key={key}>
            <span>{key}</span>
            <span>{value}</span>
          </div>
        );
      })}
    </div>
  );
}

// create the mapping
const mapping = [
  [z.string(), createDataListItemField('Text')],
  [z.boolean(), createDataListItemField('Yes or No (Boolean)')],
  [z.number(), createDataListItemField('Number')],
  [z.array(z.any()), ArraySubForm],
  [z.union(z.array(z.any())), SubForm],
  [z.record(z.any()), SubForm],
] as const; // 👈 `as const` is necessary

// A typesafe React component
export const DynamicDataList = createTsForm(mapping);
export default DynamicDataList;
